<template>
    <v-card>
        <v-card-title>
            <span class="headline">Друк журналу групи</span>
        </v-card-title>
        <v-card-text>
            <iframe v-show="!loading" :src="getPdfLink()" @load="iframeLoaded()" style="width: 100%; height: 700px; border: none;"></iframe>
            <v-layout class="d-flex justify-center" v-if="loading">
                <v-progress-circular
                        :size="150"
                        color="primary"
                        indeterminate
                ></v-progress-circular>
            </v-layout>
        </v-card-text>

        <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
                    @click="$emit('close')"
                    color="primary"
                    text
            >Відміна
            </v-btn>
        </v-card-actions>
    </v-card>
</template>

<script>
    export default {
        data: () => ({
            loading: true,
        }),
        props: {
            activeModule: {
                type: Object,
            }
        },
        methods: {
            getPdfLink() {
                return `${this.$config.apiEndpoint}/teacherMarksPdf/${this.$route.params.group}/${this.activeModule.id}`;
            },
            iframeLoaded() {
                this.loading = false;
            }
        }
    }
</script>